import React from "react";
import { Outlet } from "react-router-dom";

const GeneralLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default GeneralLayout;
